import { gql } from '@apollo/client';
import {
  ProductMasterData,
  CreateProductMasterDataInput,
  UpdateProductMasterDataInput,
  DeleteProductMasterDataInput,
} from '../types/product_master_data';
import { forPaginated } from './common/paginated.graphql';

const productMasterData = gql`
  fragment ProductMasterData on ProductMasterData {
    id
    version
    companyId
    productName
    productNumber
    lotManaged
    serialManaged
    kitManaged
    handlingUnit
    countryOfOrigin
    labels
    updatedAt
    updatedBy
    globalTradeItemNumber
    customFields {
      id
      name
      type
      value
      mandatory
    }
    grossWeight {
      value
      unit
    }
    netWeight {
      value
      unit
    }
    dimensions {
      height
      width
      depth
      unit
    }
    purchasePrice {
      value
      currency
    }
    sellingPrice {
      value
      currency
    }
    externalIdentifier {
      externalId
      settingsId
      type
      source
    }
    productCategory
    image
    originalEquipmentManufacturer
    manufacturer
    unitOfMeasure {
      system
      unit
      unitType
    }
    expiryTracking
  }
`;

const get = gql`
  query productMasterDataForCompany($companyId: String!, $page: Float) {
    productMasterDataForCompany(companyId: $companyId, page: $page) {
      data {
        ...ProductMasterData
      }
      page
      pageSize
      batchSize
      hasNext
    }
  }
  ${productMasterData}
`;

export interface GetProductMasterDataVariables {
  companyId: string;
  page?: number;
}

export interface GetProductMasterDataResponse {
  productMasterDataForCompany: PaginatedProductMasterData;
}

class PaginatedProductMasterData extends forPaginated<ProductMasterData>() {}

const create = gql`
  mutation CreateProductMasterData($productMasterData: [CreateProductMasterDataInput!]!) {
    createProductMasterData(productMasterData: $productMasterData) {
      ...ProductMasterData
    }
  }
  ${productMasterData}
`;

export interface CreateProductMasterDataVariables {
  productMasterData: CreateProductMasterDataInput[];
}

export interface CreateProductMasterDataResponse {
  createProductMasterData: ProductMasterData[];
}

const update = gql`
  mutation UpdateProductMasterData($productMasterData: [UpdateProductMasterDataInput!]!) {
    updateProductMasterData(productMasterData: $productMasterData) {
      ...ProductMasterData
    }
  }
  ${productMasterData}
`;

export interface UpdateProductMasterDataVariables {
  productMasterData: UpdateProductMasterDataInput[];
}

export interface UpdateProductMasterDataResponse {
  updateProductMasterData: ProductMasterData[];
}

const remove = gql`
  mutation DeleteProductMasterData($productMasterData: [DeleteProductMasterDataInput!]!) {
    deleteProductMasterData(productMasterData: $productMasterData) {
      ...ProductMasterData
    }
  }
  ${productMasterData}
`;

export interface DeleteProductMasterDataVariables {
  productMasterData: DeleteProductMasterDataInput[];
}

export interface DeleteProductMasterDataResponse {
  deleteProductMasterData: ProductMasterData[];
}

export const ProductMasterDataQueries = {
  get,
};

export const ProductMasterDataMutations = {
  create,
  update,
  remove,
};

export const ProductMasterDataFragments = {
  productMasterData,
};
